<template><absence-page group="vacation" /></template>
<script>
import AbsencePage from './AbsencePage'
export default { name: 'PersonalCabinetLeave', components: { AbsencePage } }
</script>
